import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import NavBarList from './NavBarList'
import NavControl from './NavControl'
import NavbarMegaMenu from './NavBarMegaMenu'
import { useScrollHook } from '../../hook/useScrollHook/useScrollHook'
import OutsideAlerter from './OutsideClick'
import Logo from '../Logo/Logo'

export function Navigation({ data, location }) {

  const scroll = useScrollHook();
  const [thisBlock, setThisBlock] = useState({});
  const [menuOpen, setMenuOpen] = useState(false);

  // Fetch menu based on WordPress menu name and location
  const menu1 = data.allMenu.nodes.filter((menu) => menu.locations.includes("MENU_LOCATION_1"));
  const menu2 = data.allMenu.nodes.filter((menu) => menu.locations.includes("MENU_LOCATION_2"));
  const menu3 = data.allMenu.nodes.filter((menu) => menu.locations.includes("MENU_LOCATION_3"));

  // Concat menus for Mega Menu component and add extra information
  const megaMenu = menu1.concat(menu2).concat(menu3)
  megaMenu.forEach( menu => {
    const menuItem = menu;

    menuItem.wrap = true;
    menuItem.menu = menu.menuItems.nodes
  })

  useEffect(() => {
    const setBlock = async() => {
      setThisBlock(document.querySelector('.component-navbar'));
    }

    setBlock()
  }, [thisBlock])

  const menuState = () => {
    setMenuOpen(!menuOpen);
  }

  return (
    <OutsideAlerter
      menuState={menuOpen}
      handleClick={menuState}>
      <div className={`component-navbar pos-relative ${(menuOpen) ? 'open' : 'close'}`}>
        <div className={`navbar-region ${(scroll.scrollPast(thisBlock)) ? 'fixed' : ''}`}>
          <div className="navbar-content-region">
            <div className="nav-control">
              <NavControl
                fixed={(scroll.scrollPast(thisBlock))}
                menuState={menuOpen}
                handleClick={menuState}
              />
            </div>
            <div className={`navbar-fixed ${(scroll.scrollPast(thisBlock)) ? 'visible' : ''}`}>
              <div className={`navbar-fixed-content `}>
                <Logo
                  uri="/"
                  text={data.wp.generalSettings.title} />
                <NavBarList
                  locationPathName={location.pathname}
                  menu={menu1[0].menuItems.nodes}
                />
              </div>
            </div>
          </div>
          <div className='navbar-menu'>
            <div className="navbar-menu-region">
              <NavbarMegaMenu
                locationPathName={location.pathname}
                menu={megaMenu}
                onHandleClick={menuState}
              />
            </div>
          </div>
        </div>
      </div>
    </OutsideAlerter>
  )
}

export default function MainNavigation({ location }) {
  const data = useStaticQuery(
    graphql`
      query {
        allMenu: allWpMenu(
          filter: {locations: {in: [MENU_LOCATION_1, MENU_LOCATION_2, MENU_LOCATION_3]}}
        ) {
          nodes {
            menuItems {
              nodes {
                id
                uri
                url
                label
              }
            }
            menuName: name
            id
            locations
          }
        }
        wp {
          generalSettings {
              title
              description
          }
        }
      }
  `)
  return (
    <Navigation data={data} location={location} />
  )
}
